module.exports = __webpack_public_path__ + "img/ic_gear_azul.1df6aa7b.svg";